<script setup lang="ts">
import { ref } from 'vue'
import ApToast from './ApToast.vue'

// We can base it on pinia / composables to trigger the radix toast from anywhere
const showToast = ref(false)
</script>

<template>
  <ApToast v-if="showToast" content="test" />
</template>
